module.exports = __webpack_public_path__ + "img/emoji_38.17f0f40c.png";